/* Port of Altea: consent-aware enquiry events for the existing GA4 property.
 * No email, name, telephone number, free text or URL query is sent.
 * This tag sends events only; Shopify's Google integration owns page views.
 */
(() => {
  'use strict';
  if (window.paLeadsInitialized) return;
  window.paLeadsInitialized = true;
  if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main') return;

  const measurementId = 'G-1S6BYT1X6H';
  const storageKey = 'pa_quote_pending_v1';
  const productCodes = new Set('pvc vinyl carpet curtains screens awnings insect shutters pergolas glass wrapping window_film exterpark other'.split(' '));
  let tagStarted = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const cleanPath = () => window.location.pathname;
  const readPending = () => {
    try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; }
  };
  const clearPending = () => { try { sessionStorage.removeItem(storageKey); } catch { /* Storage may be unavailable. */ } };
  function tag() { window.paLeadDataLayer.push(arguments); }
  const consent = (state) => ({ analytics_storage: state ? 'granted' : 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });

  function startTag() {
    if (tagStarted) return;
    tagStarted = true;
    window.paLeadDataLayer = window.paLeadDataLayer || [];
    tag('consent', 'default', consent(allowed()));
    tag('js', new Date());
    tag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: window.location.origin + cleanPath(),
      page_referrer: ''
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId + '&l=paLeadDataLayer';
    document.head.append(script);
  }

  function emit(name, details) {
    if (!allowed()) return;
    startTag();
    tag('event', name, {
      send_to: measurementId,
      page_location: window.location.origin + cleanPath(),
      page_referrer: '',
      ...details
    });
  }

  function confirmQuote() {
    if (!allowed()) { clearPending(); return; }
    if (!document.querySelector('[data-pa-quote-success]')) return;
    const pending = readPending();
    // Consume before emitting: refresh/back must never count a second lead.
    clearPending();
    if (!pending || Date.now() - pending.created > 1800000 || Date.now() < pending.created) return;
    if (typeof pending.path !== 'string' || !pending.path.startsWith('/') || !productCodes.has(pending.product)) return;
    if (pending.path !== cleanPath() && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?contact$/i.test(cleanPath())) return;
    emit('generate_lead', { form_id: 'PortOfAlteaQuote', page_location: window.location.origin + pending.path, lead_source_page: pending.path, product_interest: pending.product });
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id !== 'PortOfAlteaQuote') return;
    clearPending();
    if (!allowed() || !form.checkValidity()) return;
    const product = form.querySelector('#QuoteProduct')?.value;
    if (!productCodes.has(product)) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ path: cleanPath(), product, created: Date.now() }));
    } catch { /* The contact form continues to work without analytics storage. */ }
  });

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !allowed()) return;
    let url;
    try { url = new URL(link.href, window.location.origin); } catch { return; }
    const details = { source_page: cleanPath() };
    if (url.protocol === 'tel:') emit('phone_click', details);
    else if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) emit('whatsapp_click', details);
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (tagStarted) tag('consent', 'update', consent(allowed()));
    if (!allowed()) clearPending();
  });

  const ready = () => {
    if (document.querySelector('#PortOfAlteaQuote [role="alert"]')) clearPending();
    confirmQuote();
  };
  if (window.Shopify?.customerPrivacy) ready();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) ready(); });
  }
})();

